import axios from "axios";

export default async function commitNewObjectLater(projectName, formName, data) {
    return await axios.post(`/project/${projectName}/${formName}/add-document`, data)
}